import { Outlet } from "react-router-dom";
import usePermission from "../../Hooks/usePermission";
import Page403 from "../../Pages/Page403";

const RequirePermission = ({ permission, anyOf, children }) => {
  const { hasPermission, hasAnyPermission } = usePermission();

  const allowed = anyOf
    ? hasAnyPermission(...anyOf)
    : hasPermission(permission);

  if (!allowed) {
    // İzin yoksa 403 sayfası YERİNDE render edilir. (Navigate ile yönlendirme
    // yerine yerinde render — hedef sayfa da izinsizse yönlendirme
    // zinciri/sonsuz döngü olmaz.)
    return <Page403 />;
  }
  return children || <Outlet />;
};

export default RequirePermission;
